import type { Transaction } from "@rocicorp/zero";
import { zql } from "../zql";

export namespace Crews {
	/**
	 * This function is used to get a crew by its crewId.
	 * @param tx
	 * @param crewId
	 * @returns
	 */
	export async function getCrew(tx: Transaction, crewId: string) {
		const crew = await tx.run(zql.crews.where("id", "=", crewId).one());
		return crew;
	}

	export async function cleanCrewRankings(tx: Transaction, crewId: string) {
		const ticketAssignments = await tx.run(
			zql.ticketAssignments.where("crewId", "=", crewId).orderBy("ranking", "asc"),
		);

		let count = 0;

		for (const ticketAssignment of ticketAssignments) {
			await tx.mutate.ticketAssignments.update({ id: ticketAssignment.id, ranking: count * 100 });
			count++;
		}

		return tx;
	}

	/**
	 * Re-space a crew's staffing rankings onto the 0, 100, 200 … sequence, preserving their current
	 * order.
	 *
	 * Every write that positions a person does so relative to a neighbour, one step above or below
	 * that neighbour's ranking. That arithmetic is only unambiguous while neighbours sit a wide
	 * interval apart: without this call the gap closes with each move — 100 apart, then 1 apart,
	 * then equal — and two people holding the same ranking come back from `orderBy("ranking")` in an
	 * arbitrary order, so a dropped card lands at an unrelated end of the row. Run this after any
	 * mutation that inserts, moves or removes staffing, exactly as the ticket path does.
	 *
	 * @param tx - The Zero transaction the mutator runs in.
	 * @param crewId - The crew whose staffing sequence is rewritten.
	 * @returns The transaction, so callers can chain.
	 */
	export async function cleanCrewStaffRankings(tx: Transaction, crewId: string) {
		const userAssignments = await tx.run(
			zql.userAssignments.where("crewId", "=", crewId).orderBy("ranking", "asc"),
		);

		let count = 0;

		for (const userAssignment of userAssignments) {
			await tx.mutate.userAssignments.update({ id: userAssignment.id, ranking: count * 100 });
			count++;
		}

		return tx;
	}
}
